import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import ReactRouterPropTypes from 'react-router-prop-types'
import { withRouter } from 'react-router-dom'
import * as routes from 'core/routing/constants/index'
import MainContentWrapper from 'core/templates/MainContentWrapper'
import ImagePlaceholder from 'core/components/image-placeholder'
import wizardsShape from 'core/components/wizard/shapes'
import styled from 'styled-components'
import { FormattedMessage, injectIntl } from 'react-intl'
import { Row, Col, Card } from 'core/components/ui'
import { getCurrency } from 'core/utils/cultures/unit'
import { greys, font } from 'assets/themes/theme-default'
import { stockShape } from '../shapes'
import { tradeInShape } from '../../trade-in/shapes'

const RenderVisuVehicle = styled(Row)`
  padding: 20px;
  margin: 0 auto;
  overflow: hidden;
  img {
    max-width: 650px;
    max-height: 650px;
  }
`
const TitleWrapper = styled.h1`
  color: ${props => props.theme.colors.color2.bg};
  text-transform: uppercase;
  font-weight: ${font.weight.black};
  font-size: ${font.size.lgxxl};
  margin: 95px 0 20px;
`

const RowData = styled(Row)`
  margin: 10px;
`
const ColDataLabel = styled(Col)`
  color: ${greys.dark3};
  font-weight: ${font.weight.base};
  font-size: ${font.size.lg};
`
const ColDataValue = styled(Col)`
  text-align: right;
  color: ${props => props.theme.colors.color2.bg};
  font-weight: ${font.weight.bold};
`
const CardSectionTitle = styled(Col)`
  color: ${props => props.theme.colors.color2.bg};
  text-transform: uppercase;
  font-weight: ${font.weight.black};
  font-size: ${font.size.lgxs};
  margin: 0 0 10px;
`
const ColDataSubTotalLabel = styled(Col)`
  color: ${props => props.theme.colors.color2.bg};
  font-weight: ${font.weight.base};
  font-size: ${font.size.lgxs};
  text-transform: uppercase;
`
const SeparatorSection = styled.div`
  border-top: 1px solid ${props => props.theme.colors.color1.bg};
  margin: 15px 0;
`

/** 58px => ribbon  border-left + border-right - 2px */
const RenderCard = styled(Card)`
  &&& {
    width: calc(100% - 58px);
    margin: 0 auto;
  }
`

const Ribbon = styled(Row)`
  &&&{
    background-color: ${props => props.theme.colors.color1.bg};
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.30);
  min-height: 80px;
  padding: 20px 60px;
  z-index: 5;
  position:relative;
}
  :before {
    content: '';
    border-bottom: 15px solid ${greys.dark3};
    border-left: 30px solid transparent;
    height: 0px;
    width: 0px;
    position: absolute;
    left: -2px;
    top: -15px;
  }
  :after {
    content: '';
    border-bottom: 15px solid ${greys.dark3};
    border-right: 30px solid transparent;
    height: 0px;
    width: 0px;
    position: absolute;
    right: -2px;
    top: -15px;
  }
  }
`
const RibbonLabel = styled(Col)`
  color: ${greys.light4};
  text-transform: uppercase;
  font-weight: ${font.weight.black};
  font-size: ${font.size.lgsm};
`
const RibbonPrice = styled(Col)`
  color: ${greys.light4};
  font-weight: ${font.weight.black};
  font-size: ${font.size.lgxxl};
  text-align: right;
`
const RibbonPriceMonthly = styled(Col)`
  color: ${greys.light4};
  font-weight: ${font.weight.base};
  font-size: ${font.size.lgx};
  text-align: right;
  margin: 5px 0 0 0;
`
const ImagePlaceholderWrapper = styled.div`
  height: 300px;
  width: 100%;
`
const Finalization = props => {
  const { stock, intl, tradeIn } = props
  const { wizards, history } = props
  useEffect(() => {
    const aStepsActive = wizards[wizards.activeWizard]

    const extendedStepsActive = aStepsActive.filter(step => step.hash === routes.STOCK_FINALIZATION)
    const currentStep = extendedStepsActive[0]

    const { isActive } = currentStep

    if (!isActive) {
      history.push(routes.HOME)
    }
  }, [])

  const { selectedVehicle, funding } = stock
  const {
    brand,
    modelGroup,
    model,
    price,

    urlImage
  } = selectedVehicle

  const subTotal = price

  const { bring, monthly } = funding
  const fundingLabel = funding.label
  const fundingPrice = funding.price

  const { vehicle, tradeInprice } = tradeIn

  const urlVisuel = `${urlImage}&width=600&bLayer=0&bCrop=0&bLayer=0&FORMAT=2`

  return (
    <MainContentWrapper>
      <TitleWrapper>
        <FormattedMessage id="stock-finalization-title" />
      </TitleWrapper>
      <Row type="flex" gutter={20}>
        <Col span={12}>
          <RenderVisuVehicle type="flex" align="middle" justify="center">
            {urlImage ? (
              <img alt={`${brand} ${model}`} src={urlVisuel} />
            ) : (
              <ImagePlaceholderWrapper>
                <ImagePlaceholder />
              </ImagePlaceholderWrapper>
            )}
          </RenderVisuVehicle>
        </Col>
        <Col span={12}>
          <RenderCard
            title={intl.formatMessage({
              id: 'stock-finalization-card-title'
            })}
            bordered={false}
          >
            <RowData type="flex">
              <CardSectionTitle span={18}>
                {brand} {modelGroup}
              </CardSectionTitle>
              <ColDataValue span={6}>modifier</ColDataValue>
            </RowData>

            <RowData type="flex">
              <ColDataLabel span={18}>{model}</ColDataLabel>
              <ColDataValue span={6}>
                <FormattedMessage
                  id="stock-finalization-card-prices"
                  values={{ price, currency: getCurrency() }}
                />
              </ColDataValue>
            </RowData>

            <RowData type="flex">
              <ColDataSubTotalLabel span={18}>
                <FormattedMessage id="stock-finalization-card-label-subTtotal" />
              </ColDataSubTotalLabel>
              <ColDataValue span={6}>
                <FormattedMessage
                  id="stock-finalization-card-prices"
                  values={{ price: subTotal, currency: getCurrency() }}
                />
              </ColDataValue>
            </RowData>
            <SeparatorSection />
            <RowData type="flex">
              <CardSectionTitle span={18}>
                <FormattedMessage id="stock-finalization-card-sectionTitle1" />
              </CardSectionTitle>
              <ColDataValue span={6}>modifier</ColDataValue>
            </RowData>
            {tradeInprice ? (
              <RowData type="flex">
                <ColDataLabel span={18}>
                  {vehicle.brand} {vehicle.modelGroup} {vehicle.finishes}
                </ColDataLabel>

                <ColDataValue span={6}>{tradeInprice.amount}</ColDataValue>
              </RowData>
            ) : (
              <RowData type="flex">
                <ColDataLabel span={18}>
                  <FormattedMessage id="stock-finalization-card-without-tradeIn" />
                </ColDataLabel>
              </RowData>
            )}
            <SeparatorSection />
            <RowData type="flex">
              <CardSectionTitle span={18}>
                <FormattedMessage id="stock-finalization-card-sectionTitle2" />
              </CardSectionTitle>
              <ColDataValue span={6}>modifier</ColDataValue>
            </RowData>

            <RowData type="flex">
              <ColDataLabel span={18}>
                <FormattedMessage id="stock-finalization-card-label-4" />
              </ColDataLabel>
              <ColDataValue span={6}>
                {bring && bring !== 0 ? (
                  <FormattedMessage
                    id="stock-finalization-card-prices"
                    values={{ price: bring, currency: getCurrency() }}
                  />
                ) : (
                  <FormattedMessage id="stock-finalization-card-without-amount" />
                )}
              </ColDataValue>
            </RowData>

            {monthly && fundingLabel && (
              <RowData type="flex">
                <ColDataLabel span={18}>{fundingLabel}</ColDataLabel>
                <ColDataValue span={6}>
                  <FormattedMessage
                    id="stock-finalization-card-month"
                    values={{ months: monthly }}
                  />
                </ColDataValue>
              </RowData>
            )}
          </RenderCard>
          <Ribbon type="flex" align="middle" justify="center">
            <RibbonLabel span={10}>
              <FormattedMessage id="stock-finalization-card-label-5" />
            </RibbonLabel>
            <Col span={14}>
              <RibbonPrice>
                <FormattedMessage
                  id="stock-finalization-card-prices"
                  values={{ price, currency: getCurrency() }}
                />
              </RibbonPrice>
              {fundingPrice && (
                <RibbonPriceMonthly>
                  <FormattedMessage
                    id="stock-finalization-card-price-monthly"
                    values={{ price: fundingPrice, currency: getCurrency() }}
                  />
                </RibbonPriceMonthly>
              )}
            </Col>
          </Ribbon>

          <RenderCard>
            <Row>
              <CardSectionTitle span={18}>
                <FormattedMessage id="stock-finalization-card-sectionTitle3" />
              </CardSectionTitle>
            </Row>
          </RenderCard>
        </Col>
      </Row>
    </MainContentWrapper>
  )
}

Finalization.propTypes = {
  intl: PropTypes.shape().isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  wizards: wizardsShape.isRequired,
  stock: stockShape.isRequired,
  tradeIn: tradeInShape.isRequired
}

export default withRouter(injectIntl(Finalization))
